export default "__VITE_ASSET__DYkYO_C4__"